import React from 'react';
import RadioPill from '../radio_pill';
import styles from './index.module.css';

const RadioPillGroup = ({ name, options, value, onChange, ariaLabel }) => (
  <div className={styles.group} role='radiogroup' aria-label={ariaLabel}>
    {options.map((opt, index) => (
      <RadioPill
        key={`${index}:${opt.value}`}
        name={name}
        value={opt.value}
        label={opt.label}
        checked={value === opt.value}
        onChange={onChange}
      />
    ))}
  </div>
);

export default RadioPillGroup;
